<template>
  <div class="uploadal">
    <h2>Uploads</h2>
    <div class="announcements"
      v-for="uploadedfile in myData"
      :key="uploadedfile.id">
        <div v-if="error">
        {{ error }}
        <Spinner />
        </div>
        <div
        v-if="myData.length"
        class="layout"
        >
        <TeacherUploadDetails
            :record="uploadedfile"
            @deletion="deleted"
            />
        </div>
        <div
        v-else
        class="card"
        >
        <p>No uploads found at the moment, check back later</p>
        <Spinner />
        </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner.vue'
import TeacherUploadDetails from '@/components/TeacherUploadDetails.vue'
import getPosts from '@/composables/getPosts'

export default {
  name: 'Uploads',
  props: ['uploader'],
  components: { Spinner, TeacherUploadDetails },
  setup (props, context) {
    const { myData, error, load } = getPosts()

    load(props.uploader.grade + '/uploads/teacher')
    const deleted = () => {}

    return { error, myData, deleted }
  }
}
</script>

<style>
  .uploadal {
    max-width: 960px;
    margin: 0 auto;
  }
  .uploadal label {
    background: rgb(125, 30, 125);
    padding: 8px 12px;
    width: 200px;
    border-radius: 20px;
    height: 30px;
    color: white;
    margin: 0 auto;
  }
  .uploadal input {
    display: none;
  }
  .file-info {
    color: black;
    display: block;
  }
  .file-info-status {
    color: rosybrown;
    display: none;
  }
  .file-info-error {
    color: red;
    display: block;
  }
</style>
